import { isEmpty } from "lodash";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { getUserProfileInfo } from "../actions/userManagementActions";
import { getUserProfileInfoSelector } from "../actions/userManagementActions/selectors";
import isSiteExternal from "../utils/isSiteExternal";
export var useUserProfile = function() {
    var dispatch = useDispatch();
    var history = useHistory();
    var user = useSelector(getUserProfileInfoSelector);
    useEffect(function() {
        if (isEmpty(user) && isSiteExternal()) dispatch(getUserProfileInfo.request({
            history: history
        }));
    }, [
        dispatch,
        history,
        user
    ]);
    return user;
};
export default useUserProfile;

//# sourceMappingURL=useUserProfile.js.map